import { ReactNode } from 'react'
import Renders from '../DataTable/renders'
import ITenantUser from '../../model/ITenantUser'

export interface IUserTableAction {
  name: string
  callBack: (user: ITenantUser) => void
  render: (user?: ITenantUser) => ReactNode
  disabled: boolean | ((user: ITenantUser) => boolean)
  disableGutters: boolean
}

interface IBuildUserTableActionsOptions {
  canEdit: boolean
  canDeleteUser: (user: ITenantUser) => boolean
  onEdit: (user: ITenantUser) => void
  onDelete: (user: ITenantUser) => void
}

// Permissions are decided by the caller, so the row menu and the toolbar share
// one check. Unavailable actions stay in the menu, disabled.
export const buildUserTableActions = ({
  canEdit,
  canDeleteUser,
  onEdit,
  onDelete
}: IBuildUserTableActionsOptions): IUserTableAction[] => [
  {
    name: 'Edit',
    callBack: onEdit,
    render: () => Renders.renderEdit(!canEdit),
    disabled: !canEdit,
    disableGutters: true
  },
  {
    name: 'Delete',
    callBack: onDelete,
    render: user => Renders.renderDelete(!!user && !canDeleteUser(user)),
    disabled: user => !canDeleteUser(user),
    disableGutters: true
  }
]
